import { ReactNode } from 'react';

import SimpleModal, { Props } from 'lib/modal/simple-modal';
import {
  SimpleModalContentStyled,
  SimpleModalVerticalActionsStyled,
} from 'lib/modal/simple-modal.styles';
import { ACTIVITY_BUILDER_CLICK_CLEAR_IGNORE } from './activity-builder.constants';

export const ActivityBuilderModal = ({
  children,
  actions,
  scrollWithinModal,
  ...rest
}: Props & {
  actions?: ReactNode;
}) => (
  <SimpleModal
    openBodyClassName={ACTIVITY_BUILDER_CLICK_CLEAR_IGNORE}
    scrollWithinModal={scrollWithinModal}
    {...rest}
  >
    {scrollWithinModal ? (
      <>{children}</>
    ) : (
      <SimpleModalContentStyled>
        {children}
        {actions && (
          <SimpleModalVerticalActionsStyled>
            {actions}
          </SimpleModalVerticalActionsStyled>
        )}
      </SimpleModalContentStyled>
    )}
  </SimpleModal>
);
